const middleware = () => (next) => (action) => {
  next(action);
};
export default middleware;
